import {Accordion, Button, Card} from 'react-bootstrap'

export const LoadingOneValidation = () => {
  return (
    <div style={{marginTop: '-20px'}}>
      <Card className='mb-4 shadow-sm'>
        <Card.Header className=''>
          <Card.Title className=''>Información del Usuario</Card.Title>
          <div className='card-title d-flex align-items-center gap-2'>
            <Button size='sm' variant='outline-primary' disabled>
              <i className='bi bi-pencil' style={{color: 'inherit'}} />
            </Button>
            <Button variant='danger' size='sm' disabled>
              Anular
            </Button>
            <Button variant='info' size='sm' disabled>
              Solicitar url
            </Button>
          </div>
        </Card.Header>
        <Card.Body>
          <div className='d-flex align-items-center gap-2 my-3'>
            <i style={{fontSize: '40px'}} className='bi bi-person text-primary' />
            <div>
              <h5 className='placeholder-glow' style={{minWidth: '20ch'}}>
                <span className='placeholder col-12'></span>
              </h5>
              <p className='mb-1 text-muted d-flex align-items-center gap-2'>
                ID:
                <span className='placeholder-glow' style={{minWidth: '20ch'}}>
                  <span className='placeholder col-2'></span>
                </span>
              </p>
            </div>
          </div>
          <Accordion defaultActiveKey={['0', '1']}>
            <Accordion.Item eventKey='0'>
              <Accordion.Header>
                <i className='bi bi-card me-2' /> Detalles del Documento
              </Accordion.Header>
              <Accordion.Body>
                <p>
                  <strong>Tipo de Documento:</strong>{' '}
                  <span className='placeholder-glow' style={{minWidth: '20ch'}}>
                    <span className='placeholder col-2'></span>
                  </span>
                </p>
                <p>
                  <strong>Número:</strong>{' '}
                  <span className='placeholder-glow' style={{minWidth: '20ch'}}>
                    <span className='placeholder col-2'></span>
                  </span>
                </p>
                <p>
                  <strong>Fecha de Expedición:</strong>{' '}
                  <span className='placeholder-glow' style={{minWidth: '20ch'}}>
                    <span className='placeholder col-2'></span>
                  </span>
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey='1'>
              <Accordion.Header>
                <i className='bi bi-phone me-2' /> Información de Contacto
              </Accordion.Header>
              <Accordion.Body>
                <span className='placeholder-glow' style={{minWidth: '20ch'}}>
                  <span className='placeholder col-2'></span>
                </span>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Card.Body>
      </Card>
    </div>
  )
}
